import { render, staticRenderFns } from "./JiraProject.vue?vue&type=template&id=131e6a3e&scoped=true&"
import script from "./JiraProject.vue?vue&type=script&lang=js&"
export * from "./JiraProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e6a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131e6a3e')) {
      api.createRecord('131e6a3e', component.options)
    } else {
      api.reload('131e6a3e', component.options)
    }
    module.hot.accept("./JiraProject.vue?vue&type=template&id=131e6a3e&scoped=true&", function () {
      api.rerender('131e6a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/newProject/JiraProject.vue"
export default component.exports